import {
  GAME_ID,
  REDUX_ACTIONS,
} from '../../data/wordCityConstants';
import { getRoundTower } from './wordCitySelectors';
import { getCurriculum } from '../../lib/WordCityCurriculumManager';

const initialState = {
  isAutoOnboarding: false,
  currentStepIndex: null,
  standardItems: [],
  tower: [],
  levelIndex: null,
};

const wordCityOnboardingRoundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ONBOARDING_ROUND: {
      const { isAutoOnboarding, levelIndex } = action.payload;
      const onboardingItems = getCurriculum().onboarding.standardItems;
      return {
        ...initialState,
        standardItems: onboardingItems,
        currentStepIndex: 0,
        /* initialState, not state: its currentStepIndex is null, which is what makes getRoundTower
        return the bare reference word. Spreading the live state instead meant re-entering a round you
        had walked out of prepended another floor onto the one you left behind. */
        tower: getRoundTower({
          ...initialState,
          standardItems: onboardingItems,
        }),
        isAutoOnboarding,
        levelIndex,
      };
    }
    case REDUX_ACTIONS.NEXT_ONBOARDING_STEP: {
      const nextStepIndex = state.currentStepIndex + 1;

      return {
        ...state,
        currentStepIndex: nextStepIndex === state.standardItems.length ? null : nextStepIndex,
      };
    }
    case REDUX_ACTIONS.BUILD_ONBOARDING_TOWER: {
      return {
        ...state,
        tower: getRoundTower(state),
      };
    }
    default:
      return state;
  }
};

export default wordCityOnboardingRoundReducer;
